import { APIService } from "../../../../network/api/APIService";

export const EALinkData = ({ method = "GET", id = null, formData = {} }) => {
    let endpoint = "/ea/link/";

    if ((method === "GET" || method === "DELETE") && id) {
        endpoint += `?id=${id}`;
    }

    const config = {
        endpoint: endpoint,
        method: method,
        credentials: "include",
    };

    if (["PUT", "PATCH", "POST"].includes(method)) {
        config.data = formData;
    }

    return APIService(config);
};